import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import graphic from "../assets/empty.png";

const NoDataPlaceholder = ({message}) => {
  return (
    <Grid item xs={12}>
      <Stack direction="column" justifyContent="center" alignItems="center" spacing={2}>
        <Box sx={{mb: 2}}>
          <img width="100%" src={graphic} alt="Fazaa used cars" />
        </Box>
        <Typography variant="body1" sx={{ color: "error.main" }}>
          {message}
        </Typography>
      </Stack>
    </Grid>
  );
};

export default NoDataPlaceholder;
